import _ from 'lodash'

export const PLAYER_TYPE = {
  LIVE: 'live',
  VOD: 'vod',
  ONAIRVOD: 'onairvod',
  MOVIE: 'movie',
  BASEBALL: 'baseball'
}

export const ATTR_BY_PLAYER_TYPE = {
  live: {
    id: 'channelid',
    title: 'title'
  },
  vod: {
    id: 'contentid',
    title: 'seasontitle'
  },
  onairvod: {
    id: 'contentid',
    title: 'seasontitle'
  },
  movie: {
    id: 'movieid',
    title: 'title'
  },
  baseball: {
    id: 'contentid',
    title: 'title'
  }
}

/**
 * contentInfo 를 받아 qualities 에 있는 media type 중 가장 높은 우선순위를 출력한다.
 * @param contentInfo
 * @returns {string}
 */
export const getVideoSpec = (contentInfo) => {
  const priorityList = ['DV', 'HDR10', 'SDR'] // video quality 우선순위 오름차순 정렬 배열
  const mediatypes = _.get(contentInfo, 'qualities.mediatypes', [])
  const [ priorityQuality ] = mediatypes.map(item => `${priorityList.indexOf(item)}_${item}`).sort().map(v => v.replace(/(\d+)_/gi, ''))

  let name = ''
  let size = []
  switch (priorityQuality) {
    case 'DV' :
      name = 'dolby-vision'
      size = [ 98, 24 ]
      break

    case 'HDR10' :
      name = 'hdr'
      size = [ 56, 24 ]
      break
  }
  const [ width, height ] = size
  return { name, width, height }
}

/**
 * playtime, viewtime 를 받아 playtime 과 view time 을 뺀 값을 리턴한다. (최소값은 1, 최대값은 999)
 * @param playtime
 * @param viewtime
 * @returns {number}
 */
export const getRemainViewTime = (playtime, viewtime) => {
  const max = 999
  const min = 1
  const remainTime = Math.round((Number(playtime - viewtime)) / 60)

  if (remainTime <= min) return min
  if (remainTime >= max) return max
  return remainTime
}

/**
 * text 를 받아 html 텍스트를 랜더링한다. (v-clamp 에서 사용)
 * @param text
 * @returns {Exclude<GetFieldType<HTMLSpanElement, "textContent">, null | undefined> | string}
 */
export const getDecodedHTMLText = (text) => {
  const element = document.createElement('span')
  element.innerHTML = text
  return _.get(element, 'textContent', '')
}
